import decode from 'jwt-decode'
import axios from 'axios'
import { apiUrl } from '../constants/config'
import Store from '../Store/Store'

const REST_ENDPOINT = apiUrl
const AUTH_TOKEN_KEY = 'authToken'

export function loginUser(email, password) {
    return new Promise((resolve, reject) => {
        try {
            axios
            .post(
                apiUrl+"/api/auth/login", {email, password },
                { headers: {headers: {"X-Requested-With": "XMLHttpRequest",}}
                })
            .then(res => {
                setAuthToken(res.data.access_token)
                // Getting Current User Role
                axios.get(apiUrl+"/api/auth/user",
                        {headers: {"X-Requested-With": "XMLHttpRequest",
                        Authorization: 'Bearer ' + getAuthToken()}
                }).then( response => {
                    Store.state.Client.CurrentUser = []
                    Store.state.Client.CurrentUser = response.data
                    Store.state.Client.RolesCurrentUser = (response.data.role == 1) ? "User" : "Admin"
                    localStorage.setItem("Role", Store.state.Client.RolesCurrentUser)
                    localStorage.setItem("email-user", response.data.email)
                    localStorage.setItem("commercial_name", response.data.name)
                   
                }).catch(error => {
                    console.log(error)
                })
                
                resolve()
            })
            .catch(err => {
                console.error('Caught an error during login:', err)
                reject(err)
            })
        }
        catch (err) {
            console.error('Caught an error during login:', err)
            reject(err)
        }
    })
}

export function logoutUser() {
    clearAuthToken()
}

export function setAuthToken(token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
    localStorage.setItem(AUTH_TOKEN_KEY, token)
}

export function getUserRole() {
    return Store.state.RolesCurrentUser
}

export function getCurrentUser(){
    // return axios.get(apiUrl+"/api/auth/user",
}

export function getAuthToken() {
    return localStorage.getItem(AUTH_TOKEN_KEY)    
}

export function clearAuthToken() {
    axios.defaults.headers.common['Authorization'] = ''
    localStorage.removeItem(AUTH_TOKEN_KEY)
}

export function isLoggedIn() {
    let authToken = getAuthToken()
    return !!authToken && !isTokenExpired(authToken)
}

export function getUserInfo() {
    if (isLoggedIn()) {
        return decode(getAuthToken())
    }
}

export function whoami() {
    return new Promise((resolve, reject) => {
        try {
            axios.get(apiUrl+"/api/auth/user",
                    {headers: {"X-Requested-With": "XMLHttpRequest",
                    Authorization: 'Bearer ' + getAuthToken()}
            }).then( response => {
                Store.state.Client.CurrentUser = []
                Store.state.Client.CurrentUser = response.data
                Store.state.Client.RolesCurrentUser = (response.data.role == 1) ? "User" : "Admin"
                localStorage.setItem("Role", Store.state.Client.RolesCurrentUser)
                localStorage.setItem("email-user", response.data.email)
                localStorage.setItem("commercial_name", response.data.name)
                
            }).catch(error => {
                console.log(error)
            })
            
            resolve()
        }
        catch (err) {
            console.error('Caught an error during login:', err)
            reject(err)
        }
    })
}

function getTokenExpirationDate(encodedToken) {
    let token = decode(encodedToken)
    if (!token.exp) {
        return null
    }
  
    let date = new Date(0)
    date.setUTCSeconds(token.exp)
  
    return date
}
  
function isTokenExpired(token) {
    let expirationDate = getTokenExpirationDate(token)
    return expirationDate < new Date()
}